var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "project__color" } }, [
    _c("ul", { staticClass: "status-bar" }, [
      _c("li", {
        directives: [
          {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.html",
            modifiers: { hover: true, html: true }
          }
        ],
        style: { backgroundColor: _vm.projectColor },
        attrs: { title: "Color" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }